import { all, call, put, takeEvery } from "redux-saga/effects";

import {
  getDetailProgramFailed,
  getDetailProgramStart,
  getDetailProgramSuccess,
} from "../redux/getDetailProgram";

import { getDetailProgramApi } from "core/http/service/internalEvents";

function* getDetailProgramWork(
  action: ReturnType<typeof getDetailProgramStart>
) {
  try {
    const res = yield call(getDetailProgramApi, {
      programId: action.payload.programId,
    });

    yield put({
      type: getDetailProgramSuccess.type,
      payload: {
        data: res,
      },
    });
  } catch (error: any) {
    yield put({
      type: getDetailProgramFailed.type,
    });
  }
}

function* watchGetDetailProgram() {
  yield takeEvery(getDetailProgramStart.type, getDetailProgramWork);
}

export default function* getDetailProgramSaga() {
  yield all([watchGetDetailProgram()]);
}
